import { defineMessages } from 'react-intl';

const trns = defineMessages({
  productsWithLetter: {
    id: 'oq6jIN',
    defaultMessage: 'Препарати на літеру {letter}'
  },
  main: {
    id: '/YV5ee',
    defaultMessage: 'Головна'
  },
  letter: {
    id: '1W/2Us',
    defaultMessage: 'Літера {letter}'
  }
});

export default trns;
